/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dash-gis-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    imports: [
        MatToolbar,
        CdkScrollable,
        MatDialogContent,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatDialogActions,
        MatButton,
    ],
})
export class AlertComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public message: any, private dialogRef: MatDialogRef<AlertComponent>) {}

    close() {
        this.dialogRef.close();
    }
}
